import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import TumblrEmbed from './views/TumblrEmbed.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'Tumblr Widget',
      },
    },
    {
      path: '/embed/:blog_name/:show_description/:show_notes/:show_tags/:background_color/:header_footer_color/',
      props: true,
      component: TumblrEmbed,
      meta: {
        title: route => `${route.params.blog_name} | Tumblr Widget`,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const { title } = to.meta;
  document.title = typeof title === 'function' ? title(to) : title;
  next();
});

export default router;
